import { Link, useLocation } from "react-router-dom";
import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import { usePageSeo } from "@/hooks/usePageSeo";

export default function NotFound() {
  const location = useLocation();

  usePageSeo({
    title: "页面未找到 - 爆料大赛",
    description: "你访问的页面不存在，可以回到爆料大赛首页或直接进入参赛作品集继续浏览投稿作品。",
    path: "/404",
    type: "website",
  });

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-lg w-full text-center">
          <span className="mx-auto w-16 h-16 flex items-center justify-center rounded-full bg-accent-100 text-accent-700 text-3xl">
            <i className="ri-compass-3-line" />
          </span>
          <p className="mt-6 font-heading text-5xl md:text-6xl font-bold text-primary-200">404</p>
          <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">这个页面走丢了</h1>
          <p className="mt-3 text-sm text-foreground-600 leading-relaxed">
            你访问的地址可能已经调整，或者对应的作品还没有上线。回到首页或作品集，继续翻你感兴趣的内容。
          </p>
          <p className="mt-2 font-mono text-xs text-foreground-400 break-all">{location.pathname}</p>
          <div className="mt-7 flex flex-col sm:flex-row items-center justify-center gap-3">
            <Link
              to="/"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-1.5 bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium px-5 py-3 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              <span className="w-4 h-4 flex items-center justify-center">
                <i className="ri-home-4-line" />
              </span>
              返回首页
            </Link>
            <Link
              to="/works"
              className="w-full sm:w-auto inline-flex items-center justify-center gap-1.5 bg-background-100 hover:bg-background-200 border border-background-300 text-foreground-800 text-sm font-medium px-5 py-3 rounded-md whitespace-nowrap transition-colors cursor-pointer"
            >
              浏览参赛作品集
            </Link>
          </div>
        </div>
      </main>
      <SiteFooter />
    </div>
  );
}